'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _updeep = require('updeep');

var _updeep2 = _interopRequireDefault(_updeep);

var _expand2 = require('./_expand');

var _expand3 = _interopRequireDefault(_expand2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _expandList(root, listName, end, filler) {
    return (0, _updeep2.default)({
        list: (0, _defineProperty3.default)({}, listName, {
            entries: function entries() {
                var _entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                var length = Math.max(end + 1, _entries.length);
                return (0, _expand3.default)(_entries, length, filler);
            }
        })
    }, root || {});
}
exports.default = _expandList;